import { render, staticRenderFns } from "./PlantInfoDashboard.vue?vue&type=template&id=05334a52"
import script from "./PlantInfoDashboard.vue?vue&type=script&lang=ts"
export * from "./PlantInfoDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports